/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_BuildInputs */

const en_mobile_dev_build = /** @type {(inputs: Mobile_Dev_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const es_mobile_dev_build = /** @type {(inputs: Mobile_Dev_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Mobile_Dev_BuildInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_build = /** @type {((inputs?: Mobile_Dev_BuildInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_BuildInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_build(inputs)
	return en_mobile_dev_build(inputs)
});